import { RangeOf } from '@platform-ui-kit/components-library/dist/types/types/numberRange'
import {
  WppActionButton,
  WppBackToTopButton,
  WppBanner,
  WppButton,
  WppCard,
  WppCheckbox,
  WppDivider,
  WppFilterButton,
  WppFloatingButton,
  WppIconButton,
  WppIconFavorites,
  WppIconLockOn,
  WppIconMore,
  WppIconPlus,
  WppIconSmile,
  WppInlineMessage,
  WppInput,
  WppListItem,
  WppPill,
  WppTabs,
  WppTag,
  WppToast,
  WppTab,
  WppTypography,
  WppCardGroup,
  WppIconDocument,
  WppEmptyFolder,
  WppEmptyContent,
  WppEmptyNothingFound,
  WppEmptyNoAccess,
  WppEmptyDataviz,
} from '@platform-ui-kit/components-library-react'
import { useTranslation } from 'react-i18next'

import { CardPreview } from './components/CardPreview'
import styles from './ComponentsPreview.module.scss'
import { PAGE_PREVIEW_ID } from '../consts'

export const ComponentsPreview = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.root}>
      <div id={PAGE_PREVIEW_ID} className={styles.wrapper}>
        <WppTypography type="4xl-display" className={styles.title}>
          {t('components.title')}
        </WppTypography>

        <div className={styles.main}>
          <div className={styles.section} style={{ marginBottom: 0 }}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.buttons')}
            </WppTypography>

            <div className={styles.subSection}>
              <div className={styles.block}>
                <WppTypography type="2xs-strong" className={styles.blockLabel}>
                  {t('components.blocks.primaryRegularButton')}
                </WppTypography>

                <div className={styles.componentsList}>
                  <WppButton>{t('components.common.button')}</WppButton>
                  <WppButton className={styles.primaryButtonHover}>{t('components.common.button')}</WppButton>
                  <WppButton className={styles.primaryButtonActive}>{t('components.common.button')}</WppButton>
                  <WppButton disabled>{t('components.common.button')}</WppButton>
                </div>
              </div>

              <div className={styles.block}>
                <WppTypography type="2xs-strong" className={styles.blockLabel}>
                  {t('components.blocks.secondaryRegularButton')}
                </WppTypography>

                <div className={styles.componentsList}>
                  <WppButton variant="secondary">{t('components.common.button')}</WppButton>
                  <WppButton variant="secondary" className={styles.secondaryButtonHover}>
                    {t('components.common.button')}
                  </WppButton>
                  <WppButton variant="secondary" className={styles.secondaryButtonActive}>
                    {t('components.common.button')}
                  </WppButton>
                  <WppButton variant="secondary" disabled>
                    {t('components.common.button')}
                  </WppButton>
                </div>
              </div>
            </div>

            <div className={styles.subSection}>
              <div className={styles.block}>
                <WppTypography type="2xs-strong" className={styles.blockLabel}>
                  {t('components.blocks.primaryActionButton')}
                </WppTypography>

                <div className={styles.componentsList}>
                  <div>
                    <WppActionButton>
                      <WppIconPlus slot="icon-start" />
                      {t('components.common.action')}
                    </WppActionButton>
                  </div>
                  <div className={styles.primaryActionButtonHover}>
                    <WppActionButton>
                      <WppIconPlus slot="icon-start" />
                      {t('components.common.action')}
                    </WppActionButton>
                  </div>
                  <div className={styles.primaryActionButtonActive}>
                    <WppActionButton>
                      <WppIconPlus slot="icon-start" />
                      {t('components.common.action')}
                    </WppActionButton>
                  </div>
                  <div>
                    <WppActionButton disabled>
                      <WppIconPlus slot="icon-start" />
                      {t('components.common.action')}
                    </WppActionButton>
                  </div>
                </div>
              </div>

              <div className={styles.block}>
                <WppTypography type="2xs-strong" className={styles.blockLabel}>
                  {t('components.blocks.secondaryActionButton')}
                </WppTypography>

                <div className={styles.componentsList}>
                  <div>
                    <WppActionButton variant="secondary">
                      <WppIconPlus slot="icon-start" />
                      {t('components.common.action')}
                    </WppActionButton>
                  </div>
                  <div className={styles.secondaryActionButtonHover}>
                    <WppActionButton variant="secondary">
                      <WppIconPlus slot="icon-start" />
                      {t('components.common.action')}
                    </WppActionButton>
                  </div>
                  <div className={styles.secondaryActionButtonActive}>
                    <WppActionButton variant="secondary">
                      <WppIconPlus slot="icon-start" />
                      {t('components.common.action')}
                    </WppActionButton>
                  </div>
                  <div>
                    <WppActionButton variant="secondary" disabled>
                      <WppIconPlus slot="icon-start" />
                      {t('components.common.action')}
                    </WppActionButton>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.subSection}>
              <div className={styles.block}>
                <WppTypography type="2xs-strong" className={styles.blockLabel}>
                  {t('components.blocks.filterButton')}
                </WppTypography>

                <div className={styles.componentsList}>
                  <WppFilterButton>{t('components.common.filter')}</WppFilterButton>
                  <WppFilterButton className={styles.filterButtonHover}>
                    {t('components.common.filter')}
                  </WppFilterButton>
                  <WppFilterButton className={styles.filterButtonActive}>
                    {t('components.common.filter')}
                  </WppFilterButton>
                  <WppFilterButton disabled>{t('components.common.filter')}</WppFilterButton>
                </div>
              </div>

              <div className={styles.block}>
                <WppTypography type="2xs-strong" className={styles.blockLabel}>
                  {t('components.blocks.moreButton')}
                </WppTypography>

                <div className={styles.componentsList}>
                  <WppIconButton>
                    <WppIconMore direction="horizontal" />
                  </WppIconButton>
                  <WppIconButton className={styles.iconButtonHover}>
                    <WppIconMore direction="horizontal" />
                  </WppIconButton>
                  <WppIconButton className={styles.iconButtonActive}>
                    <WppIconMore direction="horizontal" />
                  </WppIconButton>
                  <WppIconButton disabled>
                    <WppIconMore direction="horizontal" />
                  </WppIconButton>
                </div>
              </div>
            </div>

            <div className={styles.subSection}>
              <div className={styles.block}>
                <WppTypography type="2xs-strong" className={styles.blockLabel}>
                  {t('components.blocks.floatingActionButton')}
                </WppTypography>

                <div className={styles.componentsList}>
                  <WppFloatingButton />
                  <WppFloatingButton className={styles.floatingButtonHover} />
                  <WppFloatingButton className={styles.floatingButtonActive} />
                  <WppFloatingButton disabled />
                </div>
              </div>

              <div className={styles.block}>
                <WppTypography type="2xs-strong" className={styles.blockLabel}>
                  {t('components.blocks.backToTopButton')}
                </WppTypography>

                <div className={styles.componentsList}>
                  <WppBackToTopButton />
                  <WppBackToTopButton className={styles.backToTopButtonHover} />
                  <WppBackToTopButton className={styles.backToTopButtonActive} />
                  <div />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.subSection}>
            <div className={styles.block}>
              <WppTypography type="2xs-strong" className={styles.blockLabel}>
                {t('components.blocks.primaryInvertedButton')}
              </WppTypography>

              <div className={styles.componentsList}>
                <div className={styles.invertedButtons}>
                  <WppButton variant="primary" inverted>
                    {t('components.common.button')}
                  </WppButton>
                  <WppButton className={styles.invertedPrimaryButtonHover} variant="primary" inverted>
                    {t('components.common.button')}
                  </WppButton>
                  <WppButton className={styles.invertedPrimaryButtonActive} variant="primary" inverted>
                    {t('components.common.button')}
                  </WppButton>
                  <WppButton variant="primary" inverted disabled>
                    {t('components.common.button')}
                  </WppButton>
                </div>
              </div>
            </div>

            <div className={styles.block}>
              <WppTypography type="2xs-strong" className={styles.blockLabel}>
                {t('components.blocks.secondaryInvertedButton')}
              </WppTypography>

              <div className={styles.componentsList}>
                <div className={styles.invertedButtons}>
                  <WppButton variant="secondary" inverted>
                    {t('components.common.button')}
                  </WppButton>
                  <WppButton className={styles.invertedSecondaryButtonHover} variant="secondary" inverted>
                    {t('components.common.button')}
                  </WppButton>
                  <WppButton className={styles.invertedSecondaryButtonActive} variant="secondary" inverted>
                    {t('components.common.button')}
                  </WppButton>
                  <WppButton variant="secondary" inverted disabled>
                    {t('components.common.button')}
                  </WppButton>
                </div>
              </div>
            </div>
          </div>

          <WppDivider className={styles.divider} />

          <div className={styles.section} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 0 }}>
            <div className={styles.block}>
              <WppTypography type="xl-heading" className={styles.sectionLabel}>
                {t('components.sections.list')}
              </WppTypography>

              <div className={styles.subSection}>
                <div className={styles.block}>
                  <WppTypography type="2xs-strong" className={styles.blockLabel}>
                    {t('components.blocks.singleSelection')}
                  </WppTypography>

                  <div className={styles.card}>
                    <WppListItem className={styles.listItem}>
                      <WppIconDocument slot="left" />
                      <p slot="label">{t('components.common.idle')}</p>
                    </WppListItem>
                    <WppListItem className={`${styles.listItem} ${styles.listItemHover}`}>
                      <WppIconDocument slot="left" style={{ color: 'var(--wpp-icon-color-hover)' }} />
                      <p slot="label">{t('components.common.hover')}</p>
                    </WppListItem>
                    <WppListItem className={`${styles.listItem} ${styles.listItemActive}`}>
                      <WppIconDocument slot="left" style={{ color: 'var(--wpp-icon-color-active)' }} />
                      <p slot="label">{t('components.common.pressed')}</p>
                    </WppListItem>
                    <WppListItem checked className={styles.listItem}>
                      <WppIconDocument slot="left" />
                      <p slot="label">{t('components.common.selected')}</p>
                    </WppListItem>
                    <WppListItem disabled>
                      <WppIconDocument slot="left" />
                      <p slot="label">{t('components.common.disabled')}</p>
                    </WppListItem>
                    <WppListItem className={styles.listItem}>
                      <WppIconDocument slot="left" />
                      <p slot="label">{t('components.common.idle')}</p>
                    </WppListItem>
                    <WppListItem className={styles.listItem}>
                      <WppIconDocument slot="left" />
                      <p slot="label">{t('components.common.idle')}</p>
                    </WppListItem>
                  </div>
                </div>

                <div className={styles.block}>
                  <WppTypography type="2xs-strong" className={styles.blockLabel}>
                    {t('components.blocks.multipleSelection')}
                  </WppTypography>

                  <div className={styles.card}>
                    <WppListItem multiple className={styles.listItem}>
                      <p slot="label">{t('components.common.idle')}</p>
                    </WppListItem>
                    <WppListItem multiple className={`${styles.listItem} ${styles.listItemHover}`}>
                      <p slot="label">{t('components.common.hover')}</p>
                    </WppListItem>
                    <WppListItem multiple className={`${styles.listItem} ${styles.listItemActive}`}>
                      <p slot="label">{t('components.common.pressed')}</p>
                    </WppListItem>
                    <WppListItem multiple checked className={styles.listItem}>
                      <p slot="label">{t('components.common.selectedIdle')}</p>
                    </WppListItem>
                    <div className={styles.listItemSelectedHover}>
                      <WppListItem multiple checked className={styles.listItem}>
                        <p slot="label">{t('components.common.selectedHover')}</p>
                      </WppListItem>
                    </div>
                    <div className={styles.listItemSelectedActive}>
                      <WppListItem multiple checked className={styles.listItem}>
                        <p slot="label">{t('components.common.selectedPressed')}</p>
                      </WppListItem>
                    </div>
                    <WppListItem multiple disabled className={styles.listItem}>
                      <p slot="label">{t('components.common.disabled')}</p>
                    </WppListItem>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.block}>
              <WppTypography type="xl-heading" className={styles.sectionLabel}>
                {t('components.sections.tag')}
              </WppTypography>

              <div className={styles.subSection} style={{ justifyContent: 'flex-start', marginBottom: 24 }}>
                <WppTag label={t('components.tagLabels.neutral')} variant="neutral" style={{ marginRight: 8 }} />
                <WppTag label={t('components.tagLabels.positive')} variant="positive" style={{ marginRight: 8 }} />
                <WppTag label={t('components.tagLabels.negative')} variant="negative" style={{ marginRight: 8 }} />
                <WppTag label={t('components.tagLabels.warnings')} variant="warning" style={{ marginRight: 8 }} />
              </div>
              <div className={styles.subSection} style={{ flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                {[...Array(9)].map((_, i) => (
                  <WppTag
                    key={`tag-cat-${i}`}
                    label={`${t('components.tagLabels.cat')}-${i + 1}`}
                    categoricalColorIndex={(i + 1) as Exclude<RangeOf<9>, 0>}
                    style={{ marginRight: 8, marginBottom: 8 }}
                  >
                    <WppIconSmile slot="icon-start" />
                  </WppTag>
                ))}
              </div>
            </div>
          </div>
          <WppDivider className={styles.divider} />

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.banner')}
            </WppTypography>

            <div style={{ marginBottom: 16 }}>
              <WppBanner show type="information" closable>
                {t('components.bannerMessages.info')}
              </WppBanner>
            </div>
            <WppBanner show type="warning" closable>
              {t('components.bannerMessages.highlight')}
            </WppBanner>
          </div>
          <WppDivider className={styles.divider} />

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.inlineMessage')}
            </WppTypography>

            <div className={`${styles.subSection} ${styles.withGap}`}>
              <WppInlineMessage
                className={styles.inlineMessageSection}
                size="m"
                type="warning"
                message={t('components.statusMessages.warning')}
              />
              <WppInlineMessage
                className={styles.inlineMessageSection}
                size="m"
                type="error"
                message={t('components.statusMessages.error')}
              />
              <WppInlineMessage
                className={styles.inlineMessageSection}
                size="m"
                type="success"
                message={t('components.statusMessages.success')}
              />
              <WppInlineMessage
                className={styles.inlineMessageSection}
                size="m"
                type="information"
                message={t('components.statusMessages.information')}
              />
            </div>
          </div>
          <WppDivider className={styles.divider} />

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.toastMessage')}
            </WppTypography>

            <div className={styles.subSection} style={{ flexWrap: 'wrap', gap: '16px', justifyContent: 'flex-start' }}>
              <WppToast
                type="warning"
                message={t('components.statusMessages.warning')}
                duration={60000}
                style={{ width: 400, height: 56 }}
              />
              <WppToast
                type="error"
                message={t('components.statusMessages.error')}
                duration={60000}
                style={{ width: 400, height: 56 }}
              />
              <WppToast
                type="success"
                message={t('components.statusMessages.success')}
                duration={60000}
                style={{ width: 400, height: 56 }}
              />
              <WppToast
                type="information"
                message={t('components.statusMessages.information')}
                duration={60000}
                style={{ width: 400, height: 56 }}
              />
            </div>
          </div>
          <WppDivider className={styles.divider} />

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.tabs')}
            </WppTypography>

            <WppTabs value="selected">
              <WppTab value="idle" counter={2}>
                {t('components.common.idle')}
              </WppTab>
              <WppTab value="hover" counter={2} className={styles.tabHover}>
                {t('components.common.hover')}
              </WppTab>
              <WppTab value="pressed" counter={2} className={styles.tabActive}>
                {t('components.common.pressed')}
              </WppTab>
              <WppTab value="selected" counter={2}>
                {t('components.common.selected')}
              </WppTab>
              <WppTab value="idle1" counter={2}>
                {t('components.common.idle')}
              </WppTab>
              <WppTab value="idle2" counter={2}>
                {t('components.common.idle')}
              </WppTab>
            </WppTabs>
          </div>
          <WppDivider className={styles.divider} />

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.input')}
            </WppTypography>

            <div className={styles.inputsSubSection}>
              <WppInput value={t('components.common.filled')} labelConfig={{ text: t('components.common.label') }}>
                <WppIconLockOn slot="icon-start" />
              </WppInput>
              <WppInput
                value={t('components.common.hover')}
                labelConfig={{ text: t('components.common.label') }}
                className={styles.inputHover}
              >
                <WppIconLockOn slot="icon-start" />
              </WppInput>
              <WppInput
                value=""
                placeholder={t('components.common.hint')}
                labelConfig={{ text: t('components.common.label') }}
              >
                <WppIconLockOn slot="icon-start" />
              </WppInput>
              <WppInput
                value={t('components.common.active')}
                labelConfig={{ text: t('components.common.label') }}
                className={styles.inputActive}
              >
                <WppIconLockOn slot="icon-start" />
              </WppInput>
              <WppInput value={t('components.common.disabled')} labelConfig={{ text: t('components.common.label') }}>
                <WppIconLockOn slot="icon-start" />
              </WppInput>
            </div>

            <div className={styles.inputsSubSection}>
              <WppInput
                value={t('components.common.filled')}
                labelConfig={{ text: t('components.common.label') }}
                message={t('components.statusMessages.warning')}
                messageType="warning"
              >
                <WppIconLockOn slot="icon-start" />
              </WppInput>
              <WppInput
                value={t('components.common.hover')}
                labelConfig={{ text: t('components.common.label') }}
                message={t('components.statusMessages.warning')}
                messageType="warning"
                className={styles.inputHover}
              >
                <WppIconLockOn slot="icon-start" />
              </WppInput>
              <WppInput
                value=""
                placeholder={t('components.common.hint')}
                labelConfig={{ text: t('components.common.label') }}
                message={t('components.statusMessages.warning')}
                messageType="warning"
              >
                <WppIconLockOn slot="icon-start" />
              </WppInput>
            </div>

            <div className={styles.inputsSubSection}>
              <WppInput
                value={t('components.common.filled')}
                labelConfig={{ text: t('components.common.label') }}
                message={t('components.statusMessages.error')}
                messageType="error"
              >
                <WppIconLockOn slot="icon-start" />
              </WppInput>
              <WppInput
                value={t('components.common.hover')}
                labelConfig={{ text: t('components.common.label') }}
                message={t('components.statusMessages.error')}
                messageType="error"
                className={styles.inputHover}
              >
                <WppIconLockOn slot="icon-start" />
              </WppInput>
              <WppInput
                value=""
                placeholder={t('components.common.hint')}
                labelConfig={{ text: t('components.common.label') }}
                message={t('components.statusMessages.error')}
                messageType="error"
              >
                <WppIconLockOn slot="icon-start" />
              </WppInput>
            </div>
          </div>
          <WppDivider className={styles.divider} />

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.checkbox')}
            </WppTypography>

            <div className={styles.checkboxSubSection}>
              <WppCheckbox labelConfig={{ text: t('components.common.idle') }} />
              <WppCheckbox labelConfig={{ text: t('components.common.hover') }} className={styles.checkboxHover} />
              <WppCheckbox labelConfig={{ text: t('components.common.pressed') }} className={styles.checkboxActive} />
              <WppCheckbox labelConfig={{ text: t('components.common.disabled') }} disabled />
            </div>
            <div className={styles.checkboxSubSection}>
              <WppCheckbox checked labelConfig={{ text: t('components.common.selectedIdle') }} />
              <WppCheckbox
                checked
                labelConfig={{ text: t('components.common.selectedHover') }}
                className={styles.checkboxSelectedHover}
              />
              <WppCheckbox
                checked
                labelConfig={{ text: t('components.common.selectedPressed') }}
                className={styles.checkboxSelectedActive}
              />
              <WppCheckbox checked labelConfig={{ text: t('components.common.selectedDisabled') }} disabled />
            </div>
          </div>
          <WppDivider className={styles.divider} />

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.pills')}
            </WppTypography>

            <div className={styles.pillsSubSection}>
              <WppPill>
                <WppIconFavorites slot="icon-start" />
                {t('components.common.idle')}
              </WppPill>
              <WppPill className={styles.pillsHover}>
                <WppIconFavorites slot="icon-start" style={{ color: 'var(--wpp-icon-color-hover)' }} />
                {t('components.common.hover')}
              </WppPill>
              <WppPill className={styles.pillsActive}>
                <WppIconFavorites slot="icon-start" style={{ color: 'var(--wpp-icon-color-active)' }} />
                {t('components.common.pressed')}
              </WppPill>
              <WppPill type="multiple" checked>
                <WppIconFavorites slot="icon-start" style={{ color: 'var(--wpp-primary-color-600)' }} />
                {t('components.common.selected')}
              </WppPill>
              <WppPill type="multiple" checked className={styles.pillsSelectedHover}>
                <WppIconFavorites slot="icon-start" style={{ color: 'var(--wpp-primary-color-600)' }} />
                {t('components.common.selectedHover')}
              </WppPill>
              <WppPill disabled>
                <WppIconFavorites slot="icon-start" />
                {t('components.common.disabled')}
              </WppPill>
            </div>
          </div>
          <WppDivider className={styles.divider} />

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.regularCard')}
            </WppTypography>

            <div className={styles.cardsSubSection}>
              <WppCard>
                <CardPreview title={t('components.common.title')} />
              </WppCard>
              <WppCard variant="secondary">
                <CardPreview title={t('components.common.title')} />
              </WppCard>
            </div>
          </div>

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.clickableCard')}
            </WppTypography>

            <div className={styles.cardsSubSection}>
              <WppCard interactive>
                <CardPreview title={t('components.common.idle')} />
              </WppCard>
              <WppCard interactive className={styles.clickableCardHover}>
                <CardPreview title={t('components.common.hover')} />
              </WppCard>
              <WppCard interactive className={styles.clickableCardActive}>
                <CardPreview title={t('components.common.pressed')} />
              </WppCard>
            </div>
          </div>

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.selectableCard')}
            </WppTypography>

            <WppCardGroup withRadioOrCheckbox className={styles.cardsSubSection} style={{ marginBottom: 24 }}>
              <WppCard type="single" checked={false}>
                <CardPreview title={t('components.common.idle')} withActionButton={false} />
              </WppCard>
              <WppCard type="single" checked={false} className={styles.selectableCardHover}>
                <CardPreview title={t('components.common.hover')} withActionButton={false} />
              </WppCard>
              <WppCard type="single" checked={false} className={styles.selectableCardActive}>
                <CardPreview title={t('components.common.pressed')} withActionButton={false} />
              </WppCard>
              <WppCard type="single" checked={false} disabled>
                <CardPreview title={t('components.common.disabled')} withActionButton={false} />
              </WppCard>
            </WppCardGroup>

            <WppCardGroup withRadioOrCheckbox className={styles.cardsSubSection}>
              <WppCard type="single" checked>
                <CardPreview title={t('components.common.selectedIdle')} withActionButton={false} />
              </WppCard>
              <WppCard type="single" checked>
                <CardPreview title={t('components.common.selectedHover')} withActionButton={false} />
              </WppCard>
              <WppCard type="single" checked>
                <CardPreview title={t('components.common.selectedPressed')} withActionButton={false} />
              </WppCard>
              <WppCard type="single" checked disabled>
                <CardPreview title={t('components.common.selectedDisabled')} withActionButton={false} />
              </WppCard>
            </WppCardGroup>
          </div>

          <WppDivider className={styles.divider} />

          <div className={styles.section}>
            <WppTypography type="xl-heading" className={styles.sectionLabel}>
              {t('components.sections.emptyStates')}
            </WppTypography>

            <div className={styles.emptyStatesSubSection}>
              <WppEmptyFolder />
              <WppEmptyContent />
              <WppEmptyNothingFound />
              <WppEmptyNoAccess />
              <WppEmptyDataviz />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
